import { useExperimentValue } from '@seek/candidate-feature-flag';

import { REFINE_BAR_V2_FEATURE_FLAG } from '../../config/featureFlags.ts';
import { useSelector } from '../react';

import { selectFeatureFlag } from './selectors';

export const useIsHomepageRecsBadgingStrongApplicantEnabled = () =>
  useSelector(selectFeatureFlag('homepageRecsBadgingStrongApplicant'));

export const useIsHomepageRecsBadgingExpiringSoonEarlyApplicantEnabled = () =>
  useSelector(
    selectFeatureFlag('homepageRecsBadgingExpiringSoonEarlyApplicant'),
  );

export const useIsHomepageGenAIChatEnabled = () =>
  useSelector(selectFeatureFlag('homepageGenAIChat'));

export const useIsHomepageGenAIChatAltModelEnabled = () =>
  useSelector(selectFeatureFlag('homepageGenAIChatAltModel'));

export const DynamicPillsV2 = 'dynamic-pills-v2';
export const StickySearchBar = 'sticky-search-bar';
export const RefineBarV2 = 'refine-bar-v2';
export type RefineBarV2Experiment =
  | typeof DynamicPillsV2
  | typeof StickySearchBar
  | typeof RefineBarV2;

export const useFeatureFlagRefineBarV2Experiment = () => {
  const value = useExperimentValue<RefineBarV2Experiment>(
    REFINE_BAR_V2_FEATURE_FLAG,
  );

  const dynamicPillsV2 = useSelector(selectFeatureFlag('dynamicPillsV2'));
  const stickySearchBar = useSelector(selectFeatureFlag('stickySearchBar'));
  const refineBarV2 = useSelector(selectFeatureFlag('refineBarV2'));

  return {
    dynamicPillsV2: dynamicPillsV2 || value === DynamicPillsV2,
    stickySearchBar: stickySearchBar || value === StickySearchBar,
    refineBarV2: refineBarV2 || value === RefineBarV2,
  };
};
